/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Details_Are_Strictly_UsedInputs */

const en_your_details_are_strictly_used = /** @type {(inputs: Your_Details_Are_Strictly_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your details are strictly used to send your earnings. Your ID is stored privately and only accessible by Verified Administrators.`)
};

const es_your_details_are_strictly_used = /** @type {(inputs: Your_Details_Are_Strictly_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus datos se usan estrictamente para enviarte tus ganancias. Tu identificación se almacena de forma privada y solo es accesible para Administradores Verificados.`)
};

const fr_your_details_are_strictly_used = /** @type {(inputs: Your_Details_Are_Strictly_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos coordonnées sont strictement utilisées pour vous envoyer vos gains. Votre pièce d'identité est stockée de manière privée et accessible uniquement par les administrateurs vérifiés.`)
};

const de_your_details_are_strictly_used = /** @type {(inputs: Your_Details_Are_Strictly_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Daten werden ausschließlich dazu verwendet, dir deine Einnahmen zu senden. Dein Ausweis wird privat gespeichert und ist nur für verifizierte Administratoren zugänglich.`)
};

const ja_your_details_are_strictly_used = /** @type {(inputs: Your_Details_Are_Strictly_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの詳細は収益を送金するためにのみ厳密に使用されます。身分証明書はプライベートに保管され、確認済みの管理者のみがアクセスできます。`)
};

const zh_your_details_are_strictly_used = /** @type {(inputs: Your_Details_Are_Strictly_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的详细信息严格用于向您发送收益。您的身份证件将被私密存储，只有经过验证的管理员才能访问。`)
};

const ar_your_details_are_strictly_used = /** @type {(inputs: Your_Details_Are_Strictly_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تُستخدم تفاصيلك بدقة لإرسال أرباحك إليك. يتم تخزين هويتك بشكل سري ولا يمكن الوصول إليها إلا من قِبل المسؤولين المعتمدين.`)
};

const id_your_details_are_strictly_used = /** @type {(inputs: Your_Details_Are_Strictly_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail Anda semata-mata digunakan untuk mengirimkan penghasilan Anda. ID Anda disimpan secara pribadi dan hanya dapat diakses oleh Administrator Terverifikasi.`)
};

const it_your_details_are_strictly_used = /** @type {(inputs: Your_Details_Are_Strictly_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi dettagli sono utilizzati rigorosamente per inviare i tuoi guadagni. Il tuo documento è memorizzato in modo privato e accessibile solo agli Amministratori Verificati.`)
};

const ru_your_details_are_strictly_used = /** @type {(inputs: Your_Details_Are_Strictly_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши данные используются исключительно для отправки заработанных вами средств. Ваше удостоверение хранится в закрытом доступе и доступно только верифицированным администраторам.`)
};

const pt_your_details_are_strictly_used = /** @type {(inputs: Your_Details_Are_Strictly_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os seus dados são usados estritamente para enviar seus ganhos. Sua identidade é armazenada com privacidade e acessível apenas por Administradores Verificados.`)
};

const ko_your_details_are_strictly_used = /** @type {(inputs: Your_Details_Are_Strictly_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`귀하의 정보는 수익금을 송금하는 용도로만 엄격하게 사용됩니다. 귀하의 신분증은 안전하게 보관되며 인증된 관리자만 접근할 수 있습니다.`)
};

/**
* | output |
* | --- |
* | "Your details are strictly used to send your earnings. Your ID is stored privately and only accessible by Verified Administrators." |
*
* @param {Your_Details_Are_Strictly_UsedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_details_are_strictly_used = /** @type {((inputs?: Your_Details_Are_Strictly_UsedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Details_Are_Strictly_UsedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_details_are_strictly_used(inputs)
	if (locale === "es") return es_your_details_are_strictly_used(inputs)
	if (locale === "fr") return fr_your_details_are_strictly_used(inputs)
	if (locale === "de") return de_your_details_are_strictly_used(inputs)
	if (locale === "ja") return ja_your_details_are_strictly_used(inputs)
	if (locale === "zh") return zh_your_details_are_strictly_used(inputs)
	if (locale === "ar") return ar_your_details_are_strictly_used(inputs)
	if (locale === "id") return id_your_details_are_strictly_used(inputs)
	if (locale === "it") return it_your_details_are_strictly_used(inputs)
	if (locale === "ru") return ru_your_details_are_strictly_used(inputs)
	if (locale === "pt") return pt_your_details_are_strictly_used(inputs)
	return ko_your_details_are_strictly_used(inputs)
});